import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, Modal, Spin } from 'antd';
import { RESET_USER_PASSWORD_FORM_NAME } from '../AdminPageConstants';

class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false
    };
  }

  handleSaveForm = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // this.props.form.resetFields()
        this.props.onSave(values, this.props.form);
      }
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('The two passwords you entered are incompatible!!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSave({
          password: values.password,
          token: this.props.token
        });
      }
    });
  };
  onCancel = () => {
    const form = this.props.form;
    form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loaderIsVisible } = this.props;

    return (
      <Modal
        title={`Reset password for - ${this.props.userData.email}`}
        // okText="Save"
        // cancelText="Cancel"
        visible={this.props.isVisible}
        // onOk={this.handleSaveForm}
        onCancel={this.onCancel}
        keyboard={false}
        maskClosable={false}
        footer={[
          <Button key='back' loading={loaderIsVisible} onClick={this.onCancel}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loaderIsVisible}
            onClick={this.handleSaveForm}
          >
            Save
          </Button>
        ]}
      >
        <Spin size='large' spinning={loaderIsVisible}>
          <Form layout='vertical' prefixCls='add_new_user_'>
            <Form.Item label='Password'>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'This field cannot be empty.'
                  },
                  {
                    min: 8,
                    message: 'Must be minimum 8 characters.'
                  },
                  { validator: this.validateToNextPassword }
                ]
              })(<Input type='password' autoComplete='off' />)}
            </Form.Item>
            <Form.Item label='Password confirmation'>
              {getFieldDecorator('confirm', {
                rules: [
                  {
                    required: true,
                    message: 'This field cannot be empty.'
                  },
                  { validator: this.compareToFirstPassword }
                ]
              })(
                <Input
                  type='password'
                  onBlur={this.handleConfirmBlur}
                  autoComplete='off'
                />
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

ChangePasswordForm.propTypes = {
  isVisible: PropTypes.bool,
  loaderIsVisible: PropTypes.bool,
  userData: PropTypes.object,
  onCancel: PropTypes.func,
  onSave: PropTypes.func
};

export default Form.create({ name: RESET_USER_PASSWORD_FORM_NAME })(
  ChangePasswordForm
);
